export const PHONE = 'phone'
export const LIMIT_RESULTS = 5
export const radiuses = [15, 25, 50, 100]
export const UNKNOWN_ERROR = {
  description: 'Unknown error occurred, please try again later'
}
